export const GET_META_DATA_REQUEST= 'GET_META_DATA_REQUEST';
export const GET_META_DATA_SUCCESS= 'GET_META_DATA_SUCCESS';
export const GET_META_DATA_FAIL= 'GET_META_DATA_FAIL';
